import React from "react";

const Casual = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M22.448 7.62a2.813 2.813 0 10.375-5.613 2.813 2.813 0 00-.375 5.613zM13.757 19.505a2.047 2.047 0 01-.45-.26l-1.826 3.96-1.367-.63a1.06 1.06 0 00-1.408.518l-3.608 7.825a1.06 1.06 0 00.519 1.408l.465.214a.842.842 0 101.415.652l.465.215a1.06 1.06 0 001.408-.519l3.608-7.825a1.06 1.06 0 00-.363-1.318l1.882-4.082a2.038 2.038 0 01-.74-.158z"
            fill={fill}
        />
        <path className="u_fill"
            d="M30.962 14.076l-3.813-.96-1.722-1.983.035-.52a1.9 1.9 0 00-1.769-2.023l-3.381-.226a1.9 1.9 0 00-2.012 1.655l.773-.222-3.12 1.667c-.261.14-.466.364-.58.637l-2.013 4.815a1.284 1.284 0 002.369.99l1.836-4.393 2.717-1.452-1.993 1.685-.288.688-.363 5.427.019.001c.001.063.183 3.695.272 5.478l-3.001 6.471a1.54 1.54 0 102.795 1.296l3.16-6.816a1.54 1.54 0 00.141-.725l-.274-5.497.695.047 1.704 5.068.647 7.41a1.54 1.54 0 103.069-.269l-.663-7.592a1.539 1.539 0 00-.075-.357l-1.357-4.038.042.003.372-5.572.291.335c.173.199.402.34.656.404l4.204 1.058a1.284 1.284 0 00.627-2.49z"
            fill={fill}
        />
    </svg>
);

export default Casual;